export class PrintSettings {
    private _showTherapistNotes:boolean;
    constructor() {
        this.showTherapistNotes = false;
    }


	public get showTherapistNotes(): boolean {
		return this._showTherapistNotes;
	}

	public set showTherapistNotes(value: boolean) {
		this._showTherapistNotes = value;
	}
    
}


// WEBPACK FOOTER //
// ./src/app/reports/models/print-settings.ts